import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
    RadioGroupProps,
    Tooltip,
} from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = RadioGroupProps & {
    name: string;
    options: { label: string; value: any; tooltip?: string | NonNullable<React.ReactNode> }[];
    label?: string;
    spacing?: number;
    helperText?: React.ReactNode;
};

export default function RHFRadioGroup({ row, name, label, options, spacing, helperText, ...other }: Props) {
    const { control } = useFormContext();

    const labelledby = label ? `${name}-${label}` : '';

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <FormControl component='fieldset'>
                    {label && (
                        <FormLabel component='legend' id={labelledby} sx={{ typography: 'body2' }}>
                            {label}
                        </FormLabel>
                    )}

                    <RadioGroup {...field} aria-labelledby={labelledby} row={row} {...other}>
                        {options.map(option => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={
                                    option.tooltip ? (
                                        <Tooltip title={option.tooltip} placement='top' arrow>
                                            <Radio />
                                        </Tooltip>
                                    ) : (
                                        <Radio />
                                    )
                                }
                                label={option.label}
                                sx={{
                                    '&:not(:last-of-type)': {
                                        mb: spacing || 0,
                                    },
                                    ...(row && {
                                        mr: 0,
                                        '&:not(:last-of-type)': {
                                            mr: spacing || 2,
                                        },
                                    }),
                                }}
                            />
                        ))}
                    </RadioGroup>

                    {(!!error || helperText) && (
                        <FormHelperText error={!!error} sx={{ mx: 0 }}>
                            {error ? error?.message : helperText}
                        </FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
}
